import useAdvanceTable from 'hooks/useAdvanceTable';
import React, { useEffect, useState } from 'react'
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Card, Col, Row, Form, Alert } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';

const FacilityTableView = (props) => {
    const { id } = props
    const [communicationOption, setCommunicationOptions] = useState([]);
    const [group, setGroup] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const columns = [
        {
            accessorKey: 'facility_name',
            header: 'Faciity',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                return <Link to={{ pathname: paths.editfaciliitylookupform }} state={{ obj: original }} >
                    {original.facility_name}</Link>
            }
        },
        {
            accessorKey: 'email',
            header: 'Email',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                return original.is_email ? (<FontAwesomeIcon icon="check" className="ms-1 text-success " />) : (<FontAwesomeIcon icon="check" className="ms-1 opacity-50" />)
            }
        },
        {
            accessorKey: 'fax',
            header: 'Fax',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                return original.is_fax ? (<FontAwesomeIcon icon="check" className="ms-1 text-success " />) : (<FontAwesomeIcon icon="check" className="ms-1 opacity-50" />)
            }
        },
        {
            accessorKey: 'sms',
            header: 'SMS',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                return original.is_sms ? (<FontAwesomeIcon icon="check" className="ms-1 text-success " />) : (<FontAwesomeIcon icon="check" className="ms-1 opacity-50" />)
            }
        },
        {
            accessorKey: 'liaison',
            header: 'Liaison',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                return original.is_liaison ? (<FontAwesomeIcon icon="check" className="ms-1 text-success " />) : (<FontAwesomeIcon icon="check" className="ms-1 opacity-50" />)
            }
        },
        {
            accessorKey: 'cycle_leed_day',
            header: 'Lead Days',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'delivery_time',
            header: 'Delivery Time',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        }
    ];

    const communicationmethodOptionsData = [
        {
            "key": "Email",
            "value": 1
        },
        {
            "key": "Fax",
            "value": 2
        },
        {
            "key": "SMS",
            "value": 3
        }
    ]
    useEffect(() => {
        fetchFacilityData()
    }, [])

    async function fetchFacilityData() {
        setLoading(true);
        let tokenStr = localStorage.getItem("accessToken");
        setCommunicationOptions([
            { key: 'Select', value: '' },
            ...communicationmethodOptionsData
        ])
        try{
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/facilities/list-facility/` + id, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            let objData = data.data
            let results = [];
            Object.values(objData).forEach(value => results.push({
                id: value.id,
                facility_name: value.facility_name,
                is_email: value.is_email,
                is_fax: value.is_fax,
                is_sms: value.is_sms,
                is_liaison: value.is_liaison,
                cycle_leed_day: value.cycle_leed_day,
                delivery_time: value.delivery_time,
                group_id: value.group_id,
            }));
            // results.push(objData);
            setFilteredData(results);
            setGroup(results);

        }catch (error) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleFieldChange = e => {
        const propsData = e.target.value;
        let filteredFacility;
        if (propsData == "1") {
            filteredFacility = group.filter(facility => Number(facility.is_email) === 1);
            setFilteredData(filteredFacility);
        }
        else if (propsData == "2") {
            filteredFacility = group.filter(facility => Number(facility.is_fax) === 2);
            setFilteredData(filteredFacility);
        }
        else if (propsData == "3") {
            filteredFacility = group.filter(facility => Number(facility.is_fax) === 3);
            setFilteredData(filteredFacility);
        } else {
            setFilteredData(group);
        }
    };

    const table = useAdvanceTable({
        data: filteredData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <AdvanceTableProvider {...table}>
            <Card className="mb-3">
                <Card.Body className="p-3">
                    <Row className='mt-3 justify-content-between'>
                        <Col xs="4" className="mb-2">
                            <Form.Group>
                                <Form.Label>Communication Method</Form.Label>
                                <Form.Select
                                    name="communicationmethod"
                                    onChange={handleFieldChange}
                                    size="sm"
                                >
                                    {communicationOption?.map((option) => {
                                        return (
                                            <option key={option.value} value={option.value}>
                                                {option.key}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs="4" className="mt-4">
                            <AdvanceTableSearchBox placeholder="Search..." />
                        </Col>
                    </Row>
                    <Row>
                        <Col></Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        {loading ? <ShimmerUI/> : filteredData.length > 0 ? (<Col xs="12" className="mb-1 mt-1">
                            <AdvanceTable
                                headerClassName="bg-200 text-nowrap align-middle text-center"
                                rowClassName="text-nowrap align-middle text-center"
                                tableProps={{
                                    size: 'sm',
                                    striped: true,
                                    className: 'fs-10 mb-0 overflow-hidden'
                                }}
                            />
                        </Col>) : <Alert variant="info" className="text-center mt-3">No Data Found</Alert>}
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <div className="mt-3">
                        <AdvanceTableFooter
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </div>
                </Card.Footer>
            </Card>
        </AdvanceTableProvider>
    )
}

export default FacilityTableView